import React from 'react';
import { GROUPS } from '../data/questions';

export default function ProgressBar({ currentQuestion }) {
  const group = GROUPS.find(g => {
    const start = (g.id - 1) * 5 + 1;
    const end = g.id * 5;
    return currentQuestion >= start && currentQuestion <= end;
  }) || GROUPS[0];

  const pct = ((currentQuestion - 1) / 20) * 100;

  return (
    <div style={s.wrap}>
      <div style={s.labels}>
        <span style={s.qLabel}>Question {currentQuestion} of 20</span>
        <span style={s.gLabel}>Group {group.id} of 4: {group.title}</span>
      </div>
      <div style={s.track}>
        <div style={{ ...s.fill, width: `${pct}%` }} />
      </div>
    </div>
  );
}

const s = {
  wrap: { padding: '16px 20px 0' },
  labels: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' },
  qLabel: { fontSize: '12px', fontWeight: '700', color: 'var(--navy)' },
  gLabel: { fontSize: '11px', color: 'var(--text-3)' },
  track: { height: '5px', background: 'var(--border)', borderRadius: '99px', overflow: 'hidden' },
  fill: { height: '100%', background: 'var(--navy)', borderRadius: '99px', transition: 'width 0.4s ease' },
};
